import { render, staticRenderFns } from "./ResumeRegularize.vue?vue&type=template&id=68937134&scoped=true"
import script from "./ResumeRegularize.vue?vue&type=script&lang=js"
export * from "./ResumeRegularize.vue?vue&type=script&lang=js"
import style0 from "./ResumeRegularize.vue?vue&type=style&index=0&id=68937134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68937134",
  null
  
)

export default component.exports